import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { onProductsBySeller } from '../../database/repositories/ProductRepository';

import ShowcaseCard from '../molecules/ShowcaseCard';

const Body = styled.div`
  padding: 10px;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

function UserShowcaseTab({ tabId, userId, style, ...props }) {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    const subscribe = onProductsBySeller(userId, setProducts);
    return () => subscribe();
  }, [userId]);

  if (products) {
    return (
      <Body id={tabId} style={style} {...props}>
        {products[0] ? (
          products.map((product) => <ShowcaseCard data={product} />)
        ) : (
          <p>Sem produtos</p>
        )}
      </Body>
    );
  }

  return null;
}

export default UserShowcaseTab;
